var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddTextbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.75C12.3452 5.75 12.625 6.02982 12.625 6.375V17.625C12.625 17.9702 12.3452 18.25 12 18.25C11.6548 18.25 11.375 17.9702 11.375 17.625V6.375C11.375 6.02982 11.6548 5.75 12 5.75Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.125 6.375C5.125 6.02982 5.40482 5.75 5.75 5.75H18.25C18.5952 5.75 18.875 6.02982 18.875 6.375V8.875C18.875 9.22018 18.5952 9.5 18.25 9.5C17.9048 9.5 17.625 9.22018 17.625 8.875V7H6.375V8.875C6.375 9.22018 6.09518 9.5 5.75 9.5C5.40482 9.5 5.125 9.22018 5.125 8.875V6.375Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.875 17.625C8.875 17.2798 9.15482 17 9.5 17H14.5C14.8452 17 15.125 17.2798 15.125 17.625C15.125 17.9702 14.8452 18.25 14.5 18.25H9.5C9.15482 18.25 8.875 17.9702 8.875 17.625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTextbox);
export default __webpack_public_path__ + "static/media/add-textbox.f55683e33f1cf33d69615ef3d9415c10.svg";
export { ForwardRef as ReactComponent };